const routes = [
    {
        path: "/change/major/form",
        component: () => import("../pages/MajorForm"),
        meta: {
            isAuthenticated: true,
        },
    },
];

export default routes;
